import { MijnRoute } from '../../mijn-navigatie.model';

export const INCOME_AND_EXPENSE_CATEGORY: MijnRoute = {
    path: 'categorie',
    navigationEvent: 'toInkomstenUitgavenCategorie',
    regex: /^\/inkomsten-en-uitgaven\/categorie$/,
    webcomponent: 'mijn-geld-inzicht-categorie-webcomponent'
};
